import { ModalV2, ModalV2Props } from './modal-v2';
import { ModalButtonPair, ModalButtons, ModalTitle } from './components';

type ModalV2DialogProps = Omit<ModalV2Props, 'footer' | 'header'> &
  ModalButtons & {
    title: string;
  };

export const ModalV2Dialog = ({
  children,
  title,
  primaryButton,
  secondaryButton,
  ...restProps
}: ModalV2DialogProps): JSX.Element => {
  return (
    <ModalV2
      header={<ModalTitle>{title}</ModalTitle>}
      footer={<ModalButtonPair isRightAligned primaryButton={primaryButton} secondaryButton={secondaryButton} />}
      {...restProps}
    >
      {children}
    </ModalV2>
  );
};
